module.exports = __webpack_public_path__ + "static/media/disapproval_1.99d1d190.png";